{
  "code": "EX-00",

  "@PAGE_TITLE": "Page titles section",
  "PAGE_TITLE": {
    "PRINCIPAL": "Principal",
    "ADMIN": "Administración P360",
    "ADMIN_CAMPAIGN": "Parrillas Promocionales",
    "ADMIN_CAMPAIGN_DETAILS": "Parrilla Promocional {{name}}",
    "ADMIN_DYNAMIC_FORM": "Formularios Dinámicos",
    "ADMIN_DYNAMIC_FORM_DETAILS": "Formulario Dinámico #{{id}}",
    "CRM": "Gestión visita",
    "CRM_MAP": "CRM & Rutero",
    "CRM_SCHEDULER": "Planificación",
    "CRM_REGISTRY": "Fichero",
    "CRM_CAMPAIGN": "Parrillas Promocionales",
    "CRM_MY_FORMS": "Mis Formularios",
    "AUDIT": "Analítica auditorías",
    "AUDIT_RX": "Tablero control prescriptivo RX",
    "AUDIT_RX_CUBE": "Cubo prescripciones RX",
    "AUDIT_RX_ANALYTIC": "Analítica prescripciones RX",
    "AUDIT_MX": "Tablero control mercado ventas",
    "AUDIT_MX_CUBE": "Cubo mercado ventas",
    "AUDIT_MX_ANALYTIC": "Analítica mercado ventas",
    "SELLIN": "Analítica SellIN",
    "SELLIN_PERFORMANCE": "Performance interactivo",
    "SELLIN_CONTROL_BOARD": "Tablero control P360° SellIN",
    "SELLIN_CUBE": "Cubo SellIN",
    "SELLIN_DRILLDOWN": "DrillDown perspectivas SellIN",
    "KPIS": "KPI's & BI Analytics",
    "KPIS_DASHBOARDS": "BI Analytics",
    "KPIS_DASHBOARDS_DETAIL": "BI Analytics Detalle",
    "KPIS_HEATMAP": "Mapa Calor",
    "KPIS_RADAR": "Radar líneas",
    "ABOUT_US": "Acerca de Nosotros",
    "CONTACT_US": "Contáctanos",
    "HELP_CENTER": "Ayuda",
    "NOTIFICATION": "Centro de Notificaciones",
    "NOT_FOUND": "404 - No encontrado",
    "NO_ACCESS": "404 - No encontrado",
    "FORBIDDEN": "404 - No encontrado",
    "HIDDEN_PAGES": "Escondidas por navegación",
    "PRODUCT_DETAILS": "Detalle por Producto",
    "APPOINTMENT": "Registro de Visita",
    "APPOINTMENT_OFFLINE": "Registro de Visitas [OFFLINE]",
    "ORDER": "Registro de Pedido",
    "ORDER_OFFLINE": "Registro de Pedidos [OFFLINE]",
    "CUSTOMER_DETAILS": "Detalle de Cliente",
    "CUSTOMER_CREATE": "Registro de Cliente",
    "CUSTOMER_OFFLINE": "Registro de Clientes [OFFLINE]",
    "SHORTCUT": "Accesos directos",

    "@ADMIN_CAMPAIGNS": "TODO: Remove this unused key",
    "ADMIN_CAMPAIGNS": "Parrillas Promocionales",
    "@CAMPAIGNS": "TODO: Remove this unused key",
    "CAMPAIGNS": "Parrillas Promocionales"
  },

  "@PAGE_SUBTITLE": "Page subtitles section",
  "PAGE_SUBTITLE": {
    "PERFORMANCE_BY_PRODUCT": "Rendimiento por Producto",
    "PERFORMANCE_BY_CUSTOMER": "Rendimiento por Cliente"
  },

  "@HEADINGS": "Headings section",
  "HEADINGS": {
    "ADMIN_CAMPAIGN_DETAILS_TITLE": "Composición de campañas de parrilla promocional"
  }
}
